export enum Environment {
	Development = 'development',
	Staging = 'staging',
	Prod = 'prod',
	Unknown = 'unknown',
}
